import React from "react"

import { Icon } from "@cirrus/legacy/app-components/entries/lib"
import TableColumn from "../table-column"

import styles from "../common-styles/styles.less"

function TableSortableHandlerColumn() {
  return (
    <TableColumn className={styles.handleColumn}>
      <Icon icon="icon-more2" className={styles.dndHandler} />
    </TableColumn>
  )
}

export default TableSortableHandlerColumn
